export const FONTS = [
  'Press Start 2P',
  'Roboto:400,700', 
  'Orbitron:400,700',
  'Playfair Display:400,700,400italic,700italic',
  'Source Sans Pro:400,400italic,700',
  'Cinzel:400,700'
]
